module.exports = __webpack_public_path__ + "static/media/article-default.f1bd9ad4.webp";